import React from 'react';
import './MobileTableRow.css';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';

export const MobileTableRow = ({
    rowData,
    levelIndex,
}) => {
    const {
        title,
        same_for_all,
    } = rowData;
    const baseClass = 'loyalty-level-table-mobile';
    const levelNumber = levelIndex + 1;

    const value = same_for_all
        ? rowData['unified_value']
        : rowData[`level_${levelNumber}`];
    const valueSanitized = StringUtilService.sanitizeHtml(value);

    return <div className={`${baseClass}__row`}>
        <div className={`${baseClass}__cell ${baseClass}__cell--left`}>
            {title}
        </div>
        <div className={`${baseClass}__cell ${baseClass}__cell--right`}>
            <div
                className={`${baseClass}__content-wrap`}
                dangerouslySetInnerHTML={{ __html: valueSanitized }}
            ></div>
        </div>
    </div>;
};
